import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SPACERBLOCK_LEGACY_FIELD_ORDER = [
  "height"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  spacerBlockDescriptor: _generatedSpacerBlockDescriptor,
  spacerBlockBlocDefinition,
  spacerBlockDashboardLayout,
  spacerBlockConfig,
  spacerBlockResolveConfig,
  spacerBlockProperties,
} = doodBlockConfig(
  {
    name: "Spacer",
    componentType: 'SpacerBlockComponent',
    category: 'content',
    description: "Spacer.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    height: propertyValue({
      type: 'select',
      value: "2",
      options: {
        label: "pages.blocks.spacer.height.label",
        help: "pages.blocks.spacer.height.help",
        multiple: false,
        choices: [
          { value: "0.5", label: "0.5" },
          { value: "1", label: "1" },
          { value: "1.5", label: "1.5" },
          { value: "2", label: "2" },
          { value: "2.5", label: "2.5" },
          { value: "3", label: "3" },
          { value: "3.5", label: "3.5" },
          { value: "4", label: "4" },
          { value: "5", label: "5" },
          { value: "6", label: "6" },
          { value: "7", label: "7" },
          { value: "8", label: "8" },
          { value: "9", label: "9" },
          { value: "10", label: "10" },
          { value: "11", label: "11" },
          { value: "12", label: "12" },
          { value: "14", label: "14" },
          { value: "16", label: "16" },
          { value: "20", label: "20" },
          { value: "24", label: "24" },
          { value: "28", label: "28" },
          { value: "32", label: "32" },
          { value: "36", label: "36" },
          { value: "40", label: "40" },
          { value: "44", label: "44" },
          { value: "48", label: "48" },
          { value: "52", label: "52" },
          { value: "56", label: "56" },
          { value: "60", label: "60" },
          { value: "64", label: "64" },
          { value: "72", label: "72" },
          { value: "80", label: "80" },
          { value: "96", label: "96" },
        ]
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.spacer.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.spacer.fieldset.spacing.label",
            fields: ["height"],
          },
        ],
      },
    ],
  })
);

export function spacerBlockDescriptor(): IBlockDescriptor;
export function spacerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function spacerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSpacerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSpacerBlockDescriptor, spacerBlockProperties, fieldOrder);
}

export {
  spacerBlockBlocDefinition,
  spacerBlockDashboardLayout,
  spacerBlockProperties,
  spacerBlockConfig,
  spacerBlockResolveConfig,
};

export type SpacerBlockConfig = typeof spacerBlockConfig;
